import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";
import styles from "../assets/jss/material-dashboard-react/components/buttonStyle";

export default function RegularButton(props) {
  const theme = useTheme();

  const {
    color,
    size,
    round,
    children,
    disabled,
    simple,
    block,
    link,
    justIcon,
    className,
    muiClasses,
    ...rest
  } = props;

  // Combine styles based on props
  const getMergedStyles = () => {
    return {
      ...styles.button,
      ...(size && styles[size]),
      ...(color && styles[color]),
      ...(round && styles.round),
      ...(simple && styles.simple),
      ...(block && styles.block),
      ...(link && styles.link),
      ...(justIcon && styles.justIcon),
      ...(disabled && styles.disabled),
    };
  };

  const mergedStyles = getMergedStyles();

  return (
    <Button
      {...rest}
      classes={muiClasses}
      className={classNames(className)}
      disabled={disabled}
      sx={{
        ...mergedStyles,
        // Example of using theme in sx:
        borderRadius: round ? theme.shape.borderRadius * 2 : theme.shape.borderRadius,
        padding: theme.spacing(1, 2),
        ...(disabled && {
          backgroundColor: theme.palette.action.disabledBackground,
          color: theme.palette.action.disabled,
        }),
      }}
    >
      {children}
    </Button>
  );
}

RegularButton.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "rose",
    "white",
    "transparent"
  ]),
  size: PropTypes.oneOf(["sm", "lg"]),
  simple: PropTypes.bool,
  round: PropTypes.bool,
  disabled: PropTypes.bool,
  block: PropTypes.bool,
  link: PropTypes.bool,
  justIcon: PropTypes.bool,
  className: PropTypes.string,
  muiClasses: PropTypes.object,
  children: PropTypes.node,
};
